export default "__VITE_ASSET__hC0UntQS__"